import styled from 'styled-components';
import '@carvana/showroom-css-theme/Theme.css';

const MessageWrapper = styled.div`
  display: flex;
  margin-right: 48px;
  &:last-child {
    margin-right: 0;
  }

  @media (min-width: 768px) {
    margin-right: 0;
    min-width: 158px;
  }
  @media (min-width: 1024px) {
    margin-right: 0;
    min-width: 166px;
  }
`;

const IconWrapper = styled.div`
  margin-right: 16px;
  background-color: var(--cvna-color-grey-1);
  border-radius: 8px;
  padding: 8px;
  width: 48px;
  height: 48px;
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-direction: column-reverse;
`;

const Info = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: var(--cvna-color-blue-6);
`;

const SubTitle = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #757989;
`;

export { MessageWrapper, IconWrapper, Details, Info, SubTitle };
